import React from "react"
import { Table, Form, InputNumber } from "antd"
import { handleNestedObjectKey } from "utils"
import TechBaseText from "DisplayCoreV2/Text";

const ListOptions = (props) => {
  const { dataSource } = props.item

  return (
    <Table
      rowKey="id"
      className="mt-4"
      columns={[
        {
          title: "Image",
          render: (text, record) => (
            <img
              src={
                record.site_product.site_product_images[0]?.url ||
                this.props.data.ClientReducer.clientInfo.logo_image_url
              }
              style={{ width: "100px", height: "100px", objectFit: "contain" }}
            />
          ),
        },
        {
          title: "Variant Code",
          dataIndex: "slug",
        },
        {
          title: "Product Name",
          render: (text, record) => record.site_product.name.en,
        },
        {
          title: "Variant 1",
          render: (text, record) => record.variant_level1?.name || "N/A",
        },
        {
          title: "Variant 2",
          render: (text, record) => record.variant_level2?.name || "N/A",
        },
        {
          title: "Original Price",
          dataIndex: "price_myr",
          render: (text, record) => `RM ${text.toFixed(2)}`,
        },
        {
          title: "Quantity",
          render: (text, record) => (
            <Form.Item
              className="mb-0"
              name={`q_${record.id}`}
              rules={[{ required: true, message: <TechBaseText content="{{PLEASE_ENTER_THE_QUANTITY}}" /> }]}
            >
              <InputNumber min={0} />
            </Form.Item>
          ),
        },
        {
          title: "Total PWP Price",
          render: (text, record) => (
            <Form.Item
              className="mb-0"
              name={`p_${record.id}`}
              rules={[{ required: true, message: <TechBaseText content="{{PLEASE_ENTER_AMOUNT}}" /> }]}
            >
              <InputNumber min={0} />
            </Form.Item>
          ),
        },
      ]}
      dataSource={handleNestedObjectKey(props, dataSource) || []}
    />
  )
}

export default ListOptions
